import objectUtil from '../../../static/js/objectUtil'
const getValue = objectUtil.getValueByPath
const setValue = objectUtil.setValueByPathForVue // 兼容 scanFormData 被修改后，触发响应渲染

export default {
  name: 'renderComponent',
  data() {
    return {
      goodsId: null,
    }
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
    },
    extendProps: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    value(scanFormData) {
      const parent = this.$parent?.$parent?.$parent
      //8591这里在我要验收-来自跟台目录 this.item?.props?.dataGoodsInfoKey  扫码这里取不到dataGoodsInfoKey 判断单独的item.props 是否有dataGoodsInfoKey
      const dataGoodsInfoKey = parent?.dataGoodsInfoKey
        ? parent?.dataGoodsInfoKey
        : this.item?.props?.dataGoodsInfoKey
      const goodsId = dataGoodsInfoKey ? scanFormData?.[dataGoodsInfoKey]?.id : null

      this.goodsId = goodsId
    },
  },
  methods: {
    // 设置特殊空值
    setEmptyValue(item) {
      const code = item.code
      const parent = this.$parent
      const dataGoodsKeepingKey = parent?.dataGoodsKeepingKey
      const isLink = dataGoodsKeepingKey === 'goodsStore'
      // 优联
      if (!isLink) {
        const periodEnd = objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.POLICY_ISCC_ORDER_PERIOD_END',
          null
        )
        setValue(this.value, code, periodEnd, this)
        // this.$axios.get('rest/main/system/policy/getGoodsKeepingPeriod').then((res) => {
        //   if (!this.$cfn.ajax1.isOK(res, this)) return;
        //   const _res = res.data.data
        //   // const periodBegin = _res.periodBegin
        //   const periodEnd = _res.periodEnd
        //   setValue(this.value, code, periodEnd, this)
        // })
      }
    },
  },
  render(h) {
    const code = this.item.code
    const newProps = {
      ...this.item?.props,
      styles: this.item?.style,
      disabled: this.disabled || this.item?.props?.disabled, // 解决扫码锁定时，可点击状态的切换问题
      value: getValue(this.value, this.item.code),
    }
    // #33699, 优联、灵科扫码组件中注册证号和生产许可证号的侧滑宽度改为1000px
    if (/\.(registration|certification)$/.test(code)) {
      newProps.sideModalWidth = '1000'
      console.log('renderComponent goodsId: ', this.goodsId)
      //8591 单独给注册证和生产许可证配置goodsId 不然获取不到
      if (this.item?.props?.dataGoodsInfoKey) {
        newProps.goodsId = this.goodsId
      }
      // newProps.goodsId = this.goodsId
    }
    const _components = [
      h(this.item.component || 'Input', {
        props: newProps,
        style:
          this.item.code.indexOf('amount') > -1
            ? { ...this.item.style, width: '100px' }
            : this.item.style,
        on: {
          input: (val) => {
            setValue(this.value, this.item.code, val, this)
          },
          'on-change': (val) => {
            this.$emit('on-change', val, this.item.code)
          },
          'on-keyup': (evt) => {
            const keycode = evt.keyCode || evt.which || evt.charCode
            const code = this.item.code
            const isSerial = /\.serialNumber$/.test(code) || /\.epc$/.test(code)
            if (keycode === 13 && isSerial) {
              // 回车: 原厂序列号和自定义序列号
              this.$emit('on-keyup', evt, code)
            }
          },
          'on-focus': (evt) => {
            const code = this.item.code
            this.$emit('on-focus', evt, code)
          },
        },
      }),
    ]
    const showEmptyBtn = this.extendProps?.showEmptyBtn
    // 表单项为效期，需求#5683，【优联-云南骨科-web】采购业务验收单扫码组件支持快速录入预置效期
    if (showEmptyBtn && /\.periodEnd$/.test(code)) {
      _components.push(
        // <span style="font-size: 12px;color: #FF8C00;cursor: pointer;" @click="setEmptyValue">无值</span>
        h(
          'span',
          {
            style: {
              fontSize: '12px',
              color: '#FF8C00',
              cursor: 'pointer',
              marginLeft: '6px',
            },
            on: {
              click: this.setEmptyValue.bind(this, this.item),
            },
          },
          '无值'
        )
      )
    }

    return h('div', null, _components)
  },
}
